import React from 'react';
import { Settings } from 'lucide-react';
import { OnboardingStatusBanner } from '../onboarding/components/OnboardingStatusBanner';
import { useIntegrationSetupRequests } from '../../../hooks/useIntegrationSetupRequests';
import { useHasIntegration } from '../../../hooks/useHasIntegration';
import { Organization } from '../../../types/organization.types';

interface IntegrationSetupStatusBannerProps {
  organization: Organization | null;
}

export const IntegrationSetupStatusBanner: React.FC<IntegrationSetupStatusBannerProps> = ({
  organization,
}) => {
  const hasIntegration = useHasIntegration();
  // Same gate as Upload Database button: only fetch when org has no integration yet.
  const orgId = !hasIntegration ? organization?.id : undefined;
  const { data: requests = [] } = useIntegrationSetupRequests(orgId);

  const pending = requests.filter((r) => r.status === 'pending');
  if (pending.length === 0) return null;

  const pendingFlowNames = pending.map((r) => r.flowName).filter(Boolean);

  return (
    <OnboardingStatusBanner
      icon={Settings}
      title="CRM Integration In Progress"
      variant="pink"
      defaultMinimized={true}
    >
      <p className="text-xs">
        Our team is busy setting up your CRM integration
        {pendingFlowNames.length > 0 && (
          <span className="font-semibold"> for {pendingFlowNames.join(', ')}</span>
        )}
        . Keep an eye on your inbox—we'll let you know the second the integration is complete!
      </p>
    </OnboardingStatusBanner>
  );
};
